export default options => {
  const { meta, data } = options;
  const { url } = meta;

  if (url.includes('/api/v1/course_catalogue_english/listAll')) {
    data.accent === '' && delete data.accent;
  }

  return options;
};
